<script>
import anychart from 'anychart'
import {
  insightsStatusColors,
  insightsActivityColors,
} from '@utils/design/status-css-classes'

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },

    chartData: {
      type: Array,
      default: () => [],
    },

    chartTitle: {
      type: String,
      default: () => '',
    },

    chartColor: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      chart: null,
      dataSet: null,
    }
  },

  computed: {
    chartColorPalette: function() {
      // Create color palette.
      var palette = anychart.palettes.distinctColors()
      let paletteItems = []

      if (this.chartColor === 'status') {
        this.chartData.forEach((chartDataKey) => {
          paletteItems.push(insightsStatusColors(chartDataKey.key))
        })
      } else if (this.chartColor === 'activity') {
        this.chartData.forEach((chartDataKey) => {
          paletteItems.push(insightsActivityColors(chartDataKey.key))
        })
      }

      // Set color palette.
      palette.items(paletteItems)

      return palette
    },
  },

  watch: {
    chartData() {
      this.dataSet.data(this.chartData)

      this.chart.palette(this.chartColorPalette)
    },
  },

  mounted() {
    anychart.licenseKey('openindustry.org-312f7279-c0b595db')
    // eslint-disable-next-line new-cap
    this.chart = new anychart.fromJson(this.options)

    // create data set on our data
    this.dataSet = anychart.data.set()
    // set our data to data set
    this.dataSet.data(this.chartData)

    // create pie chart with passed data set
    this.chart = anychart.pie(
      this.dataSet.mapAs({
        x: 'key',
        value: 'value',
      })
    )

    this.chart.palette(this.chartColorPalette)

    var credits = this.chart.credits()
    credits.enabled(false)

    // set the default style
    this.chart.background().fill('#1a1a1a')
    this.chart.normal().stroke('#cccccc', 2)
    this.chart.hovered().stroke('#d4d4d4', 2)
    this.chart.selected().stroke('#cccccc', 4)

    // set chart title text settings
    let customLabel = this.chart.label()
    customLabel.text(this.chartTitle)
    customLabel.position('center')
    customLabel.anchor('center')
    customLabel.hAlign('center')
    customLabel.vAlign('middle')
    customLabel.adjustFontSize(true)
    customLabel.width('45%')
    customLabel.height('7%')
    // disable legend
    this.chart.legend(false)
    // create empty area in pie chart
    this.chart.innerRadius('55%')

    // initiate chart drawing
    this.chart.container(this.$el).draw()
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    renderChart() {},
  },
}
</script>

<template>
  <div class="chart"></div>
</template>
